import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Menu = lazy(() => import('../pages/menu/page'));
const Product = lazy(() => import('../pages/product/page'));
const FindStore = lazy(() => import('../pages/find-store/page'));
const Account = lazy(() => import('../pages/account/page'));
const Auth = lazy(() => import('../pages/auth/page'));
const Checkout = lazy(() => import('../pages/checkout/page'));
const TrackOrder = lazy(() => import('../pages/track/page'));
const Merchandise = lazy(() => import('../pages/merchandise/page'));
const GiftCards = lazy(() => import('../pages/gift-cards/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const PhonePeReturn = lazy(() => import('../pages/payment/phonepe-return/page'));

const routes = [
    {
        path: '/',
        element: <Home />,
    },
    {
        path: '/menu',
        element: <Menu />,
    },
    {
        path: '/menu/:storeId',
        element: <Menu />,
    },
    {
        path: '/product/:productId',
        element: <Product />,
    },
    {
        path: '/find-store',
        element: <FindStore />,
    },
    {
        path: '/account',
        element: <Account />,
    },
    {
        path: '/auth',
        element: <Auth />,
    },
    {
        path: '/checkout',
        element: <Checkout />,
    },
    {
        path: '/track/:orderId',
        element: <TrackOrder />,
    },
    {
        path: '/merchandise',
        element: <Merchandise />,
    },
    {
        path: '/gift-cards',
        element: <GiftCards />,
    },
    {
        path: '/contact',
        element: <Contact />,
    },
    {
        path: '/payment/phonepe-return',
        element: <PhonePeReturn />,
    },
    {
        path: '*',
        element: <NotFound />,
    },
];

export default routes;
